import configuration from '@/configuration'
import { parseOrgCodeFromHost } from '@gimmatek/shared/org-code'

// appRuntime 兩種拼法都接受：其他 consumer 用 'dev'，但 .env.example 寫 'development'
const DEV_APP_RUNTIMES = ['dev', 'development']

// => 是否為可安全用環境變數覆寫 orgCode 的開發環境
// NODE_ENV 由 vue-cli-service serve 保證，.env 沒寫 VUE_APP_RUNTIME 時仍然成立
export const isDevRuntime = () =>
  process.env.NODE_ENV === 'development' ||
  DEV_APP_RUNTIMES.includes(configuration('appRuntime'))

// => 開發環境要使用的 orgCode；回空字串代表該由呼叫端自己解析 host
// 優先序跟 orgConfig.js 原本的邏輯一致，抽出來避免各處各自寫一份
export const getDevOrgCode = () => {
  if (isDevRuntime()) {
    const envOrgCode = configuration('devOrgCode')
    if (envOrgCode) return envOrgCode
  }

  if (process.env.NODE_ENV === 'development') return 'devorg'
  if (process.env.NODE_ENV === 'e2e') return 'main-test-org'

  return ''
}

// => 非正式環境（dev／e2e）：host 常是 localhost 或 IP，不屬於 base domain 也不當成錯誤
export const allowsUnknownHost = () =>
  isDevRuntime() || process.env.NODE_ENV === 'e2e'

// => 目前 host 對應的組織；overrideCode（dev 覆寫）優先
// kind: 'org'（鎖定 code）｜'entry'（入口，自行選組織）｜'invalid'（找不到組織）
// 規則在 packages/shared 的 parseOrgCodeFromHost：以 base domain 後綴比對，不看 host 段數
export const resolveStoreOrg = ({
  host = window.location.host,
  baseDomain = configuration('storeBaseDomain') || '',
  overrideCode = '',
} = {}) => {
  if (overrideCode) return { kind: 'org', code: overrideCode }

  if (!baseDomain && !allowsUnknownHost()) {
    console.error('[org] VUE_APP_STORE_BASE_DOMAIN 未設定，無法由網址解析組織')
  }

  return parseOrgCodeFromHost(host, baseDomain)
}

export const getAppVersion = () => {
  let version
  const appVersion = configuration('appVersion')
  const envVersion = process.env.VUE_APP_TAG_VERSION
  if (appVersion) {
    version = appVersion.split('-')[0]
    return version
  }
  if (envVersion) {
    version = envVersion.split('-')[0]
    return version
  }
  // return process.env.VUE_APP_VERSION.split('-')[0]
  return '0.0.0'
}
